import { render, staticRenderFns } from "./ViewerScreen.vue?vue&type=template&id=4024fbd6&"
import script from "./ViewerScreen.vue?vue&type=script&lang=js&"
export * from "./ViewerScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports